import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { McBreadcrumbsModule } from 'ngx-breadcrumbs-ui';
import { RmsHomeComponent } from './components/home/home.component';
import { RmsAccessService } from './shared/core-rms/rms-access.service';
import { NdmsRouteResolverGuard } from './../../shared/core/services/ndms-route-resolver.guard';
import { NdmsAuthenticationGuard } from '../../../ndms/app/shared/core-ndms/services/ndms-authentication.guard';
import { CurrentEventResolverGuard } from './events/shared/current-event-resolver.guard';
import { LeftNavResolverGuard } from './../../shared/core/services/left-nav-resolver-guard';
import { RmsPolicyPermissionsGuard } from './shared/core-rms/rms-policy-permissions.guard';
import { RmsPolicyPermissionsService } from './shared/core-rms/rms-policy-permissions.service';

const routes: Routes = [
  {
    path: 'rms/home',
    component: RmsHomeComponent,
    canActivateChild: [NdmsAuthenticationGuard],
    resolve: {
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      breadcrumbs: 'Home'
    }
  },
  {
    path: 'rms', redirectTo: '/rms/home', pathMatch: 'full'
  },
  {
    path: 'rms/deployment',
    loadChildren: './deployment/deployment.module#DeploymentModule',
    resolve: {
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permissions: ['Roster:Search:Access'],
      applications: ['Deployment', 'Documents'],
      breadcrumbs: 'Deployment'
    }
  },
  {
    path: 'rms/pars',
    loadChildren: './pars/pars.module#ParsModule',
    resolve: {
      event: CurrentEventResolverGuard,
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard
      
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permissions: ['Pars:Access'],
      breadcrumbs: 'PARS'
    }
  },
  {
    path: 'rms/responders',
    loadChildren: './responders/responders.module#RespondersModule',
    resolve: {
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permissions: ['Responder:Search:Access'],
      breadcrumbs: 'Responders'
    }
  },
  {
    path: 'rms/travel',
    loadChildren: './travel/travel.module#TravelModule',
    resolve: {
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard,
    },
    data: {
      service: RmsAccessService,
      breadcrumb: 'Travel',
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permissions: ['Travel:TravelRoster:Search:Access'],
      permission_application: 'Travel',
    }
  },
  {
    path: 'rms/finance',
    loadChildren: './finance/finance.module#FinanceModule',
    canActivate: [NdmsAuthenticationGuard, RmsPolicyPermissionsGuard],
    resolve: {
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard,
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permission_application: 'Finance',
      permissions: ['Finance:Access'],
      breadcrumbs: 'Finance'
    }
  },
  {
    path: 'rms/dashboard',
    loadChildren: '../../rms/app/dashboard/dashboard.module#DashboardModule',
    resolve: {
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard,
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permissions: ['Team:Search:Access']
    }
  },
  {
    path: 'rms/system-management',
    loadChildren: './rms-system-management/rms-system-management.module#RmsSystemManagementModule',
    resolve: {
      result: LeftNavResolverGuard,
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard,
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permissions: ['Admin:Access']
    }
  },
  {
    path: 'rms/reports',
    loadChildren: './reports/rms-reports.module#RmsReportsModule',
    canActivate: [NdmsAuthenticationGuard, RmsPolicyPermissionsGuard],
    resolve: {
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard,
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permission_application: 'Reports',
      permissions: ['Reports:Access'],
      breadcrumbs: 'Reports'
    }
  },
  {
    path: 'rms/events',
    loadChildren: './events/events.module#EventsModule',
    resolve: {
      response: NdmsRouteResolverGuard,
      policies: RmsPolicyPermissionsGuard,
    },
    data: {
      service: RmsAccessService,
      resolvePermissions: RmsPolicyPermissionsService.PermissionSets.Core,
      permissions: ['Events:Search:Access'],
      permission_application: 'Events',
      breadcrumbs: 'Events'
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled' }),
    McBreadcrumbsModule.forRoot()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
}
